import {MessageNotification, unreachable} from "@prosay/common"
import {getLogger} from "@prosay/logging"
import {Actions} from "react-native-router-flux"
import {NotifcationHandler} from "../types"

const logger = getLogger(__filename)

export const message: NotifcationHandler<MessageNotification> = ({
    data: {
        conversation: {id, title},
        id: highlightedMessageId,
    },
    origin,
}) => {
    switch (origin) {
        case "selected": // notification clicked on the phone
            logger.debug`Selected notification for conversation ${id} and message ${highlightedMessageId}. Navigating to message`
            Actions.messages({
                highlightedMessageId,
                id,
                title,
            })
            break
        case "received": // notification received
            // addMessageToCache
            break
        default:
            unreachable()
    }
}
